<template>
  <div :class="$style.container">
    <section :class="$style.main">
      <iSpin
        v-if="$page.resource.pending"
        fix
      />
      <slot/>
    </section>
  </div>
</template>

<script>
export default {
  name: 'LayoutEdit',
  inject: ['$page'],
};
</script>

<style lang="scss" module>
.container {
  margin: 24px;
  padding: 24px;
  background: #fff;
}


</style>
